// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"8e1823c7","735":"b8d1908b"}[chunkId] + ".chunk.js";
};